import { Box, Grow, ThemeProvider, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import ButtonMapMenuClose from "assets/icons/btn_mapmenu_close.svg";
import IconAreaPrice from "assets/icons/pricing/ic_area_price.svg";
import { EstateTypeNameEnum } from "common/enums/EstateTypeEnum";
import React from "react";
import styles from "./PricingDialog.module.scss";
import { usePricingDialogHooks } from "./hooks";
import { PricingDialogProps } from "./interfaces";
import { HouseCalculate } from "./subComponents/HouseCalculate";
import { HouseTable } from "./subComponents/HouseTable";
import { LandCalculate } from "./subComponents/LandCalculate";
import { LandTable } from "./subComponents/LandTable";
import { MansionTable } from "./subComponents/MansionTable";
import { Total } from "./subComponents/Total";

const idPrefix = "pricing-dialog";

export const PricingDialog = React.memo((props: PricingDialogProps) => {
  const hooks = usePricingDialogHooks(props);

  const { titRef, boxRef } = hooks;

  return (
    <ThemeProvider theme={hooks.mainTheme}>
      <Dialog
        open={props.open}
        aria-labelledby={`${idPrefix}-title`}
        aria-describedby={`${idPrefix}-description`}
        onClose={(e, reason) =>
          reason !== "escapeKeyDown" && props.onClose && props.onClose()
        }
        slotProps={{
          backdrop: { className: styles.backdrop }
          // paper: { onClick: hooks.onBackPaperClick }
        }}
        classes={{
          scrollPaper: styles.paperScrollPaper,
          paper: styles.paper,
          container: styles.container
        }}
        slots={{ transition: Grow }}
        transitionDuration={{ appear: 200, enter: 200, exit: 100 }}
      >
        <Box className={`${styles.popup_map} twbasic01 ${styles.on}`}>
          <Box className={styles.scroll}>
            <Box className={styles.tit} ref={titRef}>
              <Box component="span">
                <img src={IconAreaPrice} alt="ピンポイント査定" />
              </Box>
              <Box className={styles.btn_sub_close} onClick={props.onClose}>
                <img src={ButtonMapMenuClose} alt="閉じる" />
                <Typography component="b">閉じる</Typography>
              </Box>
            </Box>
            <Box className={styles.box} ref={boxRef}>
              <Box className={styles.box2}>
                <Box className={styles.ovfl}>
                  {props.estateType === EstateTypeNameEnum.土地 ||
                  props.estateType === EstateTypeNameEnum.中古戸建 ? (
                    <LandTable
                      allLandEstates={hooks.allLandEstates}
                      selectedEstateIds={hooks.selectedEstateIds}
                      onSelectEstateClick={hooks.onSelectEstateClick}
                    />
                  ) : null}
                  {props.estateType === EstateTypeNameEnum.中古戸建 ? (
                    <>
                      <HouseTable allHouseEstates={hooks.allHouseEstates} />
                    </>
                  ) : null}
                  {props.estateType === EstateTypeNameEnum.土地 ||
                  props.estateType === EstateTypeNameEnum.中古戸建 ? (
                    <LandCalculate
                      averageUnitPrice={hooks.averageUnitPrice}
                      tsuboArea={hooks.tsuboArea}
                      landAmount={hooks.landAmount}
                      onAveragePriceChange={hooks.onAveragePriceChange}
                      onTsuboAreaChange={hooks.onTsuboAreaChange}
                    />
                  ) : null}
                  {props.estateType === EstateTypeNameEnum.中古戸建 ? (
                    <>
                      <HouseCalculate
                        remainYears={hooks.remainYears}
                        remainRate={hooks.remainRate}
                        structure={hooks.structure}
                        usefulLifeYears={hooks.usefulLifeYears}
                        year={hooks.year}
                        buildPriceOfTsubo={hooks.buildPriceOfTsubo}
                        forceRemainRateTo10={hooks.forceRemainRateTo10}
                        squareArea={hooks.squareArea}
                        houseAmount={hooks.houseAmount}
                        onStructureChange={hooks.onStructureChange}
                        onStructureBlur={hooks.onStructureBlur}
                        onUsefulLifeYearsChange={hooks.onUsefulLifeYearsChange}
                        onRemainRateChange={hooks.onRemainRateChange}
                        onYearChange={hooks.onYearChange}
                        onYearBlur={hooks.onYearBlur}
                        onBuildPriceChange={hooks.onBuildPriceChange}
                        onForceRemainRateTo10Change={
                          hooks.onForceRemainRateTo10Change
                        }
                        onSquareAreaChange={hooks.onSquareAreaChange}
                      />
                      <Total
                        landAmount={hooks.landAmount}
                        houseAmount={hooks.houseAmount}
                      />
                    </>
                  ) : null}
                  {props.estateType === EstateTypeNameEnum.マンション ? (
                    <MansionTable allMansionEstates={hooks.allMansionEstates} />
                  ) : null}
                </Box>
              </Box>
              <Box className={`${styles.popup_map_btn} ${styles.btn_3ko}`}>
                <Box
                  className={`${styles.btn} ${styles.cancel}`}
                  onClick={props.onClose}
                >
                  閉じる
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </ThemeProvider>
  );
});
